import { RelatedProductsCustomState } from "@crescentParts/Store/Data/CustomRelatedProductsOnCart/RelatedProductsOnCartState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

const initialState = {
    modalIsOpen: false,
    productId: ""
};


const reducer = {
    "Custom/RelatedProductsModal/CompleteSetIsOpen":(draft:Draft<RelatedProductsCustomState>,action:{ modalIsOpen: boolean, productId: string },)=>{
        draft.modalIsOpen = action.modalIsOpen;
        draft.productId = action.productId;
    }
}

export default createTypedReducerWithImmer(initialState, reducer);